var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 107,
    viewBox: "0 0 106 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.584 63.1007L34.1952 51.7119C33.2241 50.7408 31.9881 50.2552 30.4872 50.2552C28.9864 50.2552 27.7504 50.7408 26.7793 51.7119C25.8081 52.6831 25.3226 53.9191 25.3226 55.4199C25.3226 56.9208 25.8081 58.1568 26.7793 59.1279L41.8761 74.2247C42.9355 75.2841 44.1715 75.8138 45.584 75.8138C46.9966 75.8138 48.2326 75.2841 49.292 74.2247L79.2207 44.296C80.1919 43.3248 80.6775 42.0888 80.6775 40.588C80.6775 39.0871 80.1919 37.8511 79.2207 36.88C78.2496 35.9089 77.0136 35.4233 75.5128 35.4233C74.0119 35.4233 72.7759 35.9089 71.8048 36.88L45.584 63.1007ZM53 106.537C45.6723 106.537 38.7861 105.147 32.3412 102.366C25.8964 99.5846 20.2903 95.8105 15.5229 91.043C10.7555 86.2756 6.98128 80.6695 4.20029 74.2247C1.4193 67.7799 0.0288086 60.8936 0.0288086 53.5659C0.0288086 46.2382 1.4193 39.352 4.20029 32.9072C6.98128 26.4623 10.7555 20.8562 15.5229 16.0888C20.2903 11.3214 25.8964 7.5472 32.3412 4.76621C38.7861 1.98522 45.6723 0.594727 53 0.594727C60.3277 0.594727 67.2139 1.98522 73.6588 4.76621C80.1036 7.5472 85.7097 11.3214 90.4771 16.0888C95.2445 20.8562 99.0187 26.4623 101.8 32.9072C104.581 39.352 105.971 46.2382 105.971 53.5659C105.971 60.8936 104.581 67.7799 101.8 74.2247C99.0187 80.6695 95.2445 86.2756 90.4771 91.043C85.7097 95.8105 80.1036 99.5846 73.6588 102.366C67.2139 105.147 60.3277 106.537 53 106.537Z",
    fill: "url(#paint0_linear_6258_8655)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6258_8655",
    x1: 32.4906,
    y1: 33.1055,
    x2: 77.0307,
    y2: 183.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58AF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854515,
    stopColor: "#91C153"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/check-circle-icon.f9f1f577cce0fb55a8420affcecfadbe.svg";
export { ForwardRef as ReactComponent };